module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"accept":"同意する","deny":"同意しない"},"en":{"accept":"Agree","deny":"Reject"}}')
  delete Component.options._Ctor
}
